module.exports = __webpack_public_path__ + "img/black.e667c214.png";